import { render, staticRenderFns } from "./ListChecks.vue?vue&type=template&id=bcf9bdae&"
import script from "./ListChecks.vue?vue&type=script&lang=js&"
export * from "./ListChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports